import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const PHP_API = process.env.REACT_APP_PHP_API_URL + "zuribuildAPI/";
const SITES_URL = "http://localhost/zuribuildAPI/user_websites/";

// ─── ADMIN PASSWORD (change this) ─────────────────────────────────────────────
const ADMIN_PASSWORD = "Kevin@1990";

export default function Admin() {
  const [authed, setAuthed] = useState(false);
  const [password, setPassword] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [user, setUser] = useState(null);
  const [websites, setWebsites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [creditAmount, setCreditAmount] = useState(1);

  // ─── AUTH ──────────────────────────────────────────────────────────────────
  const handleLogin = () => {
    if (password === ADMIN_PASSWORD) {
      setAuthed(true);
    } else {
      toast.error("Wrong password");
    }
  };

  // ─── SEARCH USER ───────────────────────────────────────────────────────────
  const handleSearch = async () => {
    if (!searchEmail.trim()) return;
    setLoading(true);
    setUser(null);
    setWebsites([]);
    try {
      const res = await axios.post(PHP_API + "admin_get_user.php", { email: searchEmail.trim() });
      if (res.data.success) {
        setUser(res.data.user);
        setWebsites(res.data.websites || []);
      } else {
        toast.error(res.data.message || "User not found");
      }
    } catch {
      toast.error("Server error");
    } finally {
      setLoading(false);
    }
  };

  // ─── ADD CREDITS ───────────────────────────────────────────────────────────
  const handleAddCredit = async () => {
    try {
      const res = await axios.post(PHP_API + "admin_update_credit.php", {
        user_id: user.user_id,
        amount: creditAmount,
        action: "add",
      });
      if (res.data.success) {
        setUser((prev) => ({ ...prev, credit: res.data.new_credit }));
        toast.success(`+${creditAmount} credit added. New balance: ${res.data.new_credit}`);
      } else {
        toast.error(res.data.message || "Failed");
      }
    } catch {
      toast.error("Server error");
    }
  };

  // ─── REMOVE CREDITS ────────────────────────────────────────────────────────
  const handleRemoveCredit = async () => {
    try {
      const res = await axios.post(PHP_API + "admin_update_credit.php", {
        user_id: user.user_id,
        amount: creditAmount,
        action: "remove",
      });
      if (res.data.success) {
        setUser((prev) => ({ ...prev, credit: res.data.new_credit }));
        toast.success(`-${creditAmount} credit removed. New balance: ${res.data.new_credit}`);
      } else {
        toast.error(res.data.message || "Failed");
      }
    } catch {
      toast.error("Server error");
    }
  };

  // ─── DISABLE SITE ──────────────────────────────────────────────────────────
  const handleDisable = async (websiteId, folderName, isDisabled) => {
    const action = isDisabled ? "enable" : "disable";
    if (!window.confirm(`${action} this website?`)) return;
    try {
      const res = await axios.post(PHP_API + "admin_toggle_site.php", {
        website_id: websiteId,
        folder_name: folderName,
        action,
      });
      if (res.data.success) {
        setWebsites((prev) => prev.map((w) =>
          w.website_id === websiteId ? { ...w, is_disabled: !isDisabled } : w
        ));
        toast.success(`Site ${action}d successfully`);
      } else {
        toast.error(res.data.message || "Failed");
      }
    } catch {
      toast.error("Server error");
    }
  };

  // ─── DELETE SITE ───────────────────────────────────────────────────────────
  const handleDelete = async (websiteId, folderName, websiteName) => {
    if (!window.confirm(`DELETE "${websiteName}"? This cannot be undone.`)) return;
    try {
      const res = await axios.post(PHP_API + "admin_delete_site.php", {
        website_id: websiteId,
        folder_name: folderName,
      });
      if (res.data.success) {
        setWebsites((prev) => prev.filter((w) => w.website_id !== websiteId));
        toast.success("Site deleted");
      } else {
        toast.error(res.data.message || "Failed");
      }
    } catch {
      toast.error("Server error");
    }
  };

  // ─── LOGIN SCREEN ──────────────────────────────────────────────────────────
  if (!authed) {
    return (
      <div style={styles.loginWrap}>
        <div style={styles.loginBox}>
          <img src="/zuribuild.png" style={{ width: 50, marginBottom: 8 }} alt="logo" />
          <h2 style={styles.loginTitle}>ZuriBuild Admin</h2>
          <p style={{ color: "#888", fontSize: 13, marginBottom: 20 }}>Enter admin password to continue</p>
          <input
            style={styles.input}
            type="password"
            placeholder="Admin password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
          />
          <button style={styles.btnPrimary} onClick={handleLogin}>Login</button>
        </div>
        <ToastContainer position="bottom-right" autoClose={3000} />
      </div>
    );
  }

  // ─── ADMIN DASHBOARD ───────────────────────────────────────────────────────
  return (
    <>
      <style>{`* { box-sizing: border-box; } body { margin: 0; font-family: 'Inter', -apple-system, sans-serif; background: #f5f5f7; }`}</style>

      {/* Top Bar */}
      <div style={styles.topbar}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src="/zuribuild.png" style={{ width: 36, marginTop: -6 }} alt="logo" />
          <span style={styles.logo}>ZuriBuild</span>
          <span style={{ background: "#7C3AED", color: "white", fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20, marginLeft: 4 }}>ADMIN</span>
        </div>
        <button style={styles.btnLogout} onClick={() => setAuthed(false)}>Logout</button>
      </div>

      <div style={styles.container}>

        {/* Search */}
        <div style={styles.searchBox}>
          <h5 style={{ margin: "0 0 4px", fontWeight: 700 }}>User Lookup</h5>
          <p style={{ color: "#888", fontSize: 13, margin: "0 0 16px" }}>Search by email to manage a user's account and websites</p>
          <div style={{ display: "flex", gap: 8 }}>
            <input
              style={{ ...styles.input, flex: 1, marginBottom: 0 }}
              placeholder="Enter user email..."
              value={searchEmail}
              onChange={(e) => setSearchEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
            <button style={styles.btnPrimary} onClick={handleSearch} disabled={loading}>
              {loading ? <span className="spinner-border spinner-border-sm" /> : "Search"}
            </button>
          </div>
        </div>

        {/* User Info */}
        {user && (
          <>
            <div style={styles.userCard}>
              <div style={styles.userInfo}>
                <div style={styles.avatar}>{user.full_name?.charAt(0)?.toUpperCase() || "?"}</div>
                <div>
                  <p style={styles.userName}>{user.full_name}</p>
                  <p style={styles.userEmail}>{user.email}</p>
                  <p style={styles.userId}>ID: {user.user_id}</p>
                </div>
              </div>
              <div style={styles.creditBadge}>
                <span style={styles.creditNum}>{user.credit}</span>
                <span style={styles.creditLabel}>Credits</span>
              </div>
            </div>

            {/* Credit Management */}
            <div style={styles.creditBox}>
              <h6 style={{ margin: "0 0 12px", fontWeight: 700 }}>Credit Management</h6>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                <select
                  style={{ ...styles.input, width: "auto", marginBottom: 0 }}
                  value={creditAmount}
                  onChange={(e) => setCreditAmount(Number(e.target.value))}
                >
                  {[1, 2, 3, 5, 10].map((n) => (
                    <option key={n} value={n}>{n} credit{n > 1 ? "s" : ""}</option>
                  ))}
                </select>
                <button style={styles.btnAdd} onClick={handleAddCredit}>
                  <i className="bi bi-plus-lg" /> Add Credits
                </button>
                <button style={styles.btnRemove} onClick={handleRemoveCredit}>
                  <i className="bi bi-dash-lg" /> Remove Credits
                </button>
              </div>
            </div>

            {/* Websites */}
            <div style={styles.sitesSection}>
              <h6 style={{ margin: "0 0 16px", fontWeight: 700 }}>
                Websites ({websites.length})
              </h6>
              {websites.length === 0 ? (
                <p style={{ color: "#aaa", fontSize: 13 }}>No websites found for this user.</p>
              ) : (
                <div style={styles.sitesGrid}>
                  {websites.map((site) => (
                    <div key={site.website_id} style={{ ...styles.siteCard, opacity: site.is_disabled ? 0.6 : 1 }}>
                      <div style={styles.siteHeader}>
                        <div>
                          <p style={styles.siteName}>{site.website_name}</p>
                          <p style={styles.siteFolder}>{site.folder_name}</p>
                        </div>
                        {site.is_disabled ? (
                          <span style={styles.badgeDisabled}>Disabled</span>
                        ) : (
                          <span style={styles.badgeActive}>Active</span>
                        )}
                      </div>
                      <div style={styles.siteDates}>
                        <span>Created: {new Date(site.created_at).toLocaleDateString()}</span>
                        <span>Expires: {new Date(site.expiry_date).toLocaleDateString()}</span>
                      </div>
                      <div style={styles.siteActions}>
                        <a
                          href={SITES_URL + site.folder_name + "/"}
                          target="_blank"
                          rel="noreferrer"
                          style={styles.btnView}
                        >
                          <i className="bi bi-eye" /> View
                        </a>
                        <a
                          href={`/edit-website/${site.folder_name}`}
                          target="_blank"
                          rel="noreferrer"
                          style={styles.btnEdit}
                        >
                          <i className="bi bi-pencil" /> Edit
                        </a>
                        <button
                          style={site.is_disabled ? styles.btnEnable : styles.btnDisable}
                          onClick={() => handleDisable(site.website_id, site.folder_name, site.is_disabled)}
                        >
                          <i className={`bi ${site.is_disabled ? "bi-toggle-on" : "bi-toggle-off"}`} />
                          {site.is_disabled ? " Enable" : " Disable"}
                        </button>
                        <button
                          style={styles.btnDelete}
                          onClick={() => handleDelete(site.website_id, site.folder_name, site.website_name)}
                        >
                          <i className="bi bi-trash" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </>
  );
}

const styles = {
  loginWrap: { display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#f5f5f7" },
  loginBox: { background: "white", borderRadius: 16, padding: 32, width: 360, textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.08)" },
  loginTitle: { fontSize: 22, fontWeight: 800, color: "#7C3AED", margin: "0 0 4px" },
  topbar: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 24px", background: "white", borderBottom: "1px solid #eee", position: "sticky", top: 0, zIndex: 100 },
  logo: { fontSize: 22, fontWeight: 800, color: "#7C3AED", letterSpacing: "-0.5px" },
  btnLogout: { background: "transparent", border: "1px solid #eee", borderRadius: 8, padding: "6px 14px", fontSize: 13, cursor: "pointer", color: "#555" },
  container: { maxWidth: 860, margin: "0 auto", padding: "24px 16px" },
  searchBox: { background: "white", borderRadius: 12, padding: 20, marginBottom: 20, border: "1px solid #eee" },
  userCard: { background: "white", borderRadius: 12, padding: 20, marginBottom: 16, border: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 },
  userInfo: { display: "flex", alignItems: "center", gap: 14 },
  avatar: { width: 48, height: 48, borderRadius: "50%", background: "#7C3AED", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, fontWeight: 700, flexShrink: 0 },
  userName: { fontWeight: 700, fontSize: 16, margin: "0 0 2px" },
  userEmail: { color: "#555", fontSize: 13, margin: "0 0 2px" },
  userId: { color: "#aaa", fontSize: 11, margin: 0 },
  creditBadge: { display: "flex", flexDirection: "column", alignItems: "center", background: "#f3f0ff", borderRadius: 12, padding: "12px 20px", minWidth: 80 },
  creditNum: { fontSize: 28, fontWeight: 800, color: "#7C3AED", lineHeight: 1 },
  creditLabel: { fontSize: 11, color: "#7C3AED", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" },
  creditBox: { background: "white", borderRadius: 12, padding: 20, marginBottom: 20, border: "1px solid #eee" },
  sitesSection: { background: "white", borderRadius: 12, padding: 20, border: "1px solid #eee" },
  sitesGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 14 },
  siteCard: { border: "1px solid #eee", borderRadius: 10, padding: 14, transition: "opacity 0.2s" },
  siteHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 },
  siteName: { fontWeight: 600, fontSize: 14, margin: "0 0 2px" },
  siteFolder: { color: "#aaa", fontSize: 11, margin: 0 },
  siteDates: { display: "flex", flexDirection: "column", gap: 2, fontSize: 11, color: "#aaa", marginBottom: 12 },
  siteActions: { display: "flex", gap: 6 },
  badgeActive: { background: "#f0fdf4", color: "#16a34a", fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20, flexShrink: 0 },
  badgeDisabled: { background: "#fff0f0", color: "#e11d48", fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20, flexShrink: 0 },
  btnView: { flex: 1, background: "#f3f0ff", color: "#7C3AED", border: "none", borderRadius: 7, padding: "6px 0", fontSize: 12, cursor: "pointer", textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "center", gap: 4 },
  btnEdit: { flex: 1, background: "#eff6ff", color: "#2563eb", border: "none", borderRadius: 7, padding: "6px 0", fontSize: 12, cursor: "pointer", textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "center", gap: 4 },
  btnDisable: { flex: 1, background: "#fff7ed", color: "#ea580c", border: "none", borderRadius: 7, padding: "6px 0", fontSize: 12, cursor: "pointer" },
  btnEnable: { flex: 1, background: "#f0fdf4", color: "#16a34a", border: "none", borderRadius: 7, padding: "6px 0", fontSize: 12, cursor: "pointer" },
  btnDelete: { background: "#fff0f0", color: "#e11d48", border: "none", borderRadius: 7, padding: "6px 10px", fontSize: 12, cursor: "pointer" },
  input: { background: "#f9f9f9", border: "1px solid #e5e5e5", borderRadius: 8, padding: "8px 12px", fontSize: 14, color: "#1a1a1a", width: "100%", marginBottom: 12, outline: "none" },
  btnPrimary: { background: "#7C3AED", color: "white", border: "none", borderRadius: 8, padding: "8px 20px", fontSize: 14, cursor: "pointer", fontWeight: 600 },
  btnAdd: { background: "#7C3AED", color: "white", border: "none", borderRadius: 8, padding: "8px 16px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 4 },
  btnRemove: { background: "#fff0f0", color: "#e11d48", border: "1px solid #fecaca", borderRadius: 8, padding: "8px 16px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 4 },
};